
























































import { Component, Vue } from "vue-property-decorator";
import { UsersApi } from "@/services/api-service";
import { EmailWithConfirm } from "@/api/api";
import { UserRegisterStatus } from "@/types";
import UserModule from "@/store/user";
import CTooltip from "@/components/CTooltip.vue";
import TooltipModule from "@/store/tooltip";
import FormModal from "./FormModal.vue";

@Component({
  components: {
    FormModal,
    CTooltip,
  },
})
export default class CPreRegisterFormResend extends Vue {
  private mounted() {
    UserModule.commitPreRegisterStatus(UserRegisterStatus.Edit);
  }

  private form: EmailWithConfirm = {
    email: "",
    confirmEmail: "",
  };

  private get isTooltipShow() {
    return TooltipModule.isShow;
  }

  private get userRegisterStatus() {
    return UserRegisterStatus;
  }

  private get preRegisterStatus() {
    return UserModule.preRegisterStatus;
  }

  private confirm() {
    window.scrollTo(0, 0);
    UserModule.commitPreRegisterStatus(UserRegisterStatus.Confirm);
  }

  private async submit() {
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const userRes = await UsersApi.instance.sendUserRegistToken(this.form);
      if (!userRes?.data?.data?.token) {
        return;
      }
      (this.$refs.test as FormModal).CtestShow();
      window.scrollTo(0, 0);
    } catch (err) {
      TooltipModule.commitIsShow(true);
      setTimeout(() => {
        TooltipModule.commitIsShow(false);
      }, 5000);
    }
  }

  private backEdit() {
    window.scrollTo(0, 0);
    UserModule.commitPreRegisterStatus(UserRegisterStatus.Edit);
  }
}
